import React, { useEffect, useState, useContext } from 'react'
import "./Repair.css"
import { useStateWithCallbackLazy } from 'use-state-with-callback'
import { Table, Button, Spinner, Form, Row, Col } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faTimesCircle, faCheckCircle, faAsterisk, faRedoAlt } from '@fortawesome/free-solid-svg-icons'
import { listTask, taskStatus, getRefresh, addRefresh, updateRefresh, listRepairType } from '../Network/Repair'
import { listCompany } from '../Network/Company'
import { Loading, TablePagination, Container, HeaderTitle } from '../Library'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import dayjs from 'dayjs'
import Ping from '../asset/sound/ping.wav'
import { setDocumentTitle } from '../AppTitle'
import DatePicker from "react-datepicker";
import { baseURL } from '../Network/Config'

function Repair() {
    var autoRefresh;
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.repair_service
    const langError = langCx.lang.error
    const notifyCx = useContext(NotifyContext)
    const [isFirst, setIsFirst] = useState(true)
    
    const autoRefreshSecond = 15;
    const [isLoading, setLoading] = useState(false);
    const [miniLoading, setMiniLoading] = useState(false);
    const [taskList, setTaskList]= useState([])
    const [repairTypeList, setRepairTypeList] = useState([])
    const [selectRepairType, setSelectRepairType] = useState("")
    const [companyList, setCompanyList] = useState([])
    const [selectCompany, setSelectCompany] = useState("")
    const [lastUpdate, setLastupdate] = useState("");
    var prevTasklistSize = 0

    const [status, setStatus] = useStateWithCallbackLazy("ALL")
    const [startDate, setStartDate] = useStateWithCallbackLazy(null);
    const [endDate, setEndDate] = useStateWithCallbackLazy(null);

    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [totalPage, setTotalPage] = useState(0)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage

    async function fetchTask(page, size, status, startDate, endDate, repairTypeId, companyId, isExport){
        setMiniLoading(true)
        
        console.log('Page : ' + page)
        console.log('size : ' + size)
        console.log('status : '+ status)
        console.log('startDate : '+ startDate)
        console.log('endDate : '+ endDate)
        console.log('repairTypeId : '+ repairTypeId)
        console.log('companyId : '+ companyId)
        console.log('isExport : '+ isExport)

        listTask(page, size , status, startDate, endDate, repairTypeId, companyId, isExport,
            (data)=>{
                setIsFirst(false)
                setTotalPage(Math.ceil(data.count / size))
                if(!isExport){
                    setTaskList(data.content)
                    console.log(data.content)
                    if(prevTasklistSize === 0){
                        prevTasklistSize = data.count
                    }else if(data.content.length > prevTasklistSize){
                        playPingsound()
                        prevTasklistSize = data.count
                        notifyCx.showNotify(lang.new_task, lang.new_task_desc, 1)
                        
                    }
                    // updateRefresh(false,
                    //     ()=>{},
                    //     (error)=>{
                    //         notifyCx.showNotify(langError.something_wrong, error.message, 2)
                    //     })
                }else{
                    window.open(baseURL + "/" + data.path, "_self")
                }

                setMiniLoading(false)
            },
            (error)=>{
                setMiniLoading(false)
                console.log(error.response.data)
                if(error.response !== undefined){
                    if(error.response.status === 401){
                        notifyCx.showNotify(langError.something_wrong, langError.user_expired, 1)
                    }else{
                        notifyCx.showNotify(langError.something_wrong, error.message, 2)
                    }
                }else{
                    notifyCx.showNotify(langError.something_wrong, error.message, 2)
                }
            }
        )
    }

    function fetchRepairType(){
        listRepairType(
            (data)=>{
                setRepairTypeList(data)
            },
            (error)=>{
                notifyCx.showNotify(langError.something_wrong, error.message, 2)
            }
        )
    }

    function fetchCompany(){
        listCompany(
            (data)=>{
                setCompanyList(data)
            },
            (error)=>{
                notifyCx.showNotify(langError.something_wrong, error.message, 2)
            }
        )
    }

    function refreshStatus(){
        getRefresh(
            (data)=>{
                setLastupdate(dayjs().format("H:mm - D MMMM YYYY"))
                if(data === ""){
                    addRefresh(false,
                        (callback)=>{},
                        (error)=>{
                            notifyCx.showNotify(langError.something_wrong, error.message, 2)
                        })
                }

                if(data.refresh === true){
                    fetchTask(status, startDate, endDate, selectRepairType, selectCompany, false)
                }
            },
            (error)=>{
                notifyCx.showNotify(langError.something_wrong, error.message, 2)
            }
        )
    }

    useEffect(()=>{
        setDocumentTitle("Repair Tasks")
        fetchCompany()
        fetchRepairType()
        fetchTask(currentPage, perPage, status, startDate, endDate, selectRepairType, selectCompany, false);
        //refreshStatus()
        if(isFirst){
            autoRefresh = setInterval(()=>{
                //refreshStatus()
                fetchTask(currentPage, perPage, status, startDate, endDate, selectRepairType, selectCompany, false)
            }, autoRefreshSecond * 1000)
        }
        return(()=>{
            clearInterval(autoRefresh)
        })
    },[currentPage, status, startDate, endDate, selectRepairType, selectCompany])

    const playPingsound = () =>{
        const audio = new Audio(Ping)
        audio.play()
    }

    const clearFilter = () =>{
        setCurrentPage(1)
        setStatus("ALL")
        setStartDate(null)
        setEndDate(null)
        setSelectRepairType("")
        setSelectCompany("")
    }

    const getExcel = () =>{
        fetchTask(currentPage, perPage, status, startDate, endDate, selectRepairType, selectCompany, true)
    }

    const goToFirstPage = () => {
        setCurrentPage(1)
    }

    return (
        <Container topbarTitle={langCx.lang.sidebar.repair_task}>
        { isLoading ? <Loading title="Loading task list"/> : null }
        <div id="repair">
            <HeaderTitle 
            title={lang.task} 
            description={
                <>
                <div>{lang.task_desc}</div>
                <div>{lang.last_update} : {lastUpdate} <FontAwesomeIcon icon={faRedoAlt}/></div>
                </>
            }
            customRight={
                miniLoading ? 
                <Spinner 
                variant="primary" 
                animation="border" 
                className="spinner"/>
                : null
            }
            />
            <div style={{marginBottom: 20}}>
                <Row>
                    <Col md={6} lg={3}>
                        <Form.Group>
                            <Form.Label>{lang.status}</Form.Label>
                            <Form.Control as="select" value={status} 
                            onChange={(e)=>{
                                goToFirstPage()
                                setStatus(e.target.value)
                            }}>
                                <option value="ALL">{lang.all}</option>
                                <option value="CREATE">{lang.created}</option>
                                <option value="WAITING">{lang.waiting}</option>
                                <option value="IN_PROGRESS">{lang.in_progress}</option>
                                <option value="COMPLETE">{lang.complete}</option>
                                <option value="CANCEL">{lang.cancelled}</option>
                            </Form.Control>
                        </Form.Group>
                        
                    </Col>
                    <Col md={6} lg={4}>
                        <Form.Group>
                            <Form.Label>{lang.start_date}</Form.Label>
                            <div>
                            <DatePicker 
                            selected={startDate}
                            onChange={(date)=>{
                                goToFirstPage()
                                setStartDate(date)
                            }}
                            className="form-control" 
                            dateFormat="d MMMM yyyy"
                            placeholderText={lang.start_date}
                            maxDate={new Date()}
                            />
                            </div>
                        </Form.Group>
                    </Col>
                    <Col md={6} lg={4}>
                        <Form.Group>
                            <Form.Label>{lang.end_date}</Form.Label>
                            <div>
                            <DatePicker 
                            selected={endDate}
                            onChange={(date)=>{
                                goToFirstPage()
                                setEndDate(date)
                            }}
                            className="form-control" 
                            dateFormat="d MMMM yyyy"
                            placeholderText={lang.end_date}
                            maxDate={new Date()}
                            minDate={startDate}
                            />
                            </div>
                        </Form.Group>
                    </Col>
                    <Col md={6} lg={4}>
                        <Form.Group>
                            <Form.Label>{lang.service_type}</Form.Label>
                            <Form.Control as="select"
                            value={selectRepairType}
                            onChange={(e)=>{
                                goToFirstPage()
                                setSelectRepairType(e.target.value)
                            }}
                            >
                                <option value={""}>{lang.no_selection}</option>
                                { repairTypeList.map((item, key)=>
                                    <option key={key} value={item.id}>{langCx.code === "th" ? item.name : item.nameEn}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={6} lg={4}>
                        <Form.Group>
                            <Form.Label>{lang.company}</Form.Label>
                            <Form.Control as="select"
                            value={selectCompany}
                            onChange={(e)=>{
                                goToFirstPage()
                                setSelectCompany(e.target.value)
                            }}
                            >
                                <option value={""}>{lang.no_selection}</option>
                                { companyList.map((item, key)=>
                                    <option key={key} value={item.id}>{item.name}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <div className="filter-button">
                    {/* <Button onClick={()=>{
                        setCurrentPage(1)
                        fetchTask(status, startDate, endDate, selectRepairType, selectCompany, false)
                    }}>
                        {lang.preview}
                    </Button> */}
                    <span style={{ marginRight: 20 }}>{lang.auto_filter}</span>
                    <Button 
                    variant="secondary"
                    onClick={()=>clearFilter()}>
                        {lang.clear}
                    </Button>
                    <Button 
                    variant="success"
                    onClick={()=>getExcel()}>
                        {lang.export}
                    </Button>
                </div>
            </div>
            <div className="table-container">
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.ticket_number}</th>
                            <th>{lang.datetime}</th>
                            <th>{lang.company}</th>
                            <th>{lang.status}</th>
                            <th>{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { taskList
                        .map((item, key)=>
                            <TaskRow
                            key={key}
                            id={item.id}
                            status={item.status}
                            ticket={item.ticketNumber}
                            company={item.company}
                            date={item.createdDate}
                            isNew={
                                dayjs(new Date()).diff(item.createdDate, 'minute') < 60 && item.status === taskStatus.CREATE ?
                                true :false
                            }
                            />
                        )}
                        { taskList.length === 0 ?
                        <tr style={{textAlign: 'center'}}>
                            <td colSpan={6}>{lang.no_task}</td>
                        </tr>
                        : null
                        }
                    </tbody>
                </Table>
                
            </div>
            <div className="bottom-pagination">
                <TablePagination
                dataLength={totalPage}
                size={10}
                currentPage={currentPage}
                handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                firstPageClick={(first)=>{ setCurrentPage(first) }}
                lastPageClick={(last)=>{ setCurrentPage(last) }}
                disabledPrev={currentPage === indexOfFirst + 1}
                disabledNext={currentPage === totalPage}
                />
            </div>
        </div>
        </Container>
    )
}
export default Repair

function TaskRow(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.repair_service
    const history = useHistory()

    const convertDate = (date) =>{
        let toDate = new Date(date)
        let formattedDate = dayjs(toDate).format("D MMM YYYY H:mm")
        return formattedDate
    }

    let statusIcon
    let color
    let statusText

    switch (props.status) {
        case(taskStatus.CREATE):
            statusIcon = faAsterisk
            color = "orange"
            statusText = lang.created
            break;
        case(taskStatus.WAITING):
            statusIcon = faClock
            color = "orange"
            statusText = lang.waiting
            break;
        case(taskStatus.IN_PROGRESS):
            statusIcon = faClock
            color = "#3a88bc"
            statusText = lang.in_progress
            break;
        case(taskStatus.COMPLETE):
            statusIcon = faCheckCircle
            color = "green"
            statusText = lang.complete
            break;
        case(taskStatus.CANCEL):
            statusIcon = faTimesCircle
            color = "red"
            statusText = lang.cancelled
            break;
        default:
            statusIcon = faTimesCircle
            color = "red"
            statusText = "No status"
            break;
    }

    return(
        <tr style={{
            backgroundColor: props.isNew ? 'lightyellow' : null
        }}>
            <td 
            style={{color: color, textAlign: 'center'}} 
            className="col-status">
                <FontAwesomeIcon icon={statusIcon}/>
            </td>
            <td>{props.ticket}</td>
            <td>{convertDate(props.date)}</td>
            <td>{props.company}</td>
            <td>{statusText}</td>
            <td style={{textAlign:"center"}}>
                <Button 
                size="sm" 
                style={{width: 90}}
                onClick={()=>history.push("/repair/"+props.id)}
                >
                    {lang.see_detail}
                </Button>
            </td>
        </tr>
    )
}